// v3/config/navigation.config.ts — Sidebar navigation items
//
// All imports from v3 — zero imports from v1/v2.
// Each item has a featureId for permission filtering via canAccessFeature().

import type { NavigationItem } from './types';

// ─── Sidebar Navigation Items ────────────────────────────────────────────────

export const NAVIGATION_ITEMS: NavigationItem[] = [
  {
    label: 'Dashboard',
    path: '/',
    icon: 'LayoutDashboard',
    featureId: 'dashboard',
  },
  {
    label: 'Leads',
    path: '/leads',
    icon: 'Users',
    featureId: 'leads',
  },
  {
    label: 'Applications',
    path: '/applications',
    icon: 'FileText',
    featureId: 'applications',
  },
  {
    label: 'Groups',
    path: '/groups',
    icon: 'UsersRound',
    featureId: 'groups',
  },
  {
    label: 'Tasks',
    path: '/tasks',
    icon: 'CheckSquare',
    featureId: 'tasks',
  },
  {
    label: 'Login History',
    path: '/login-history',
    icon: 'History',
    featureId: 'login-history',
  },
  {
    label: 'EMI Calculator',
    path: '/emi-calculator',
    icon: 'Calculator',
    featureId: 'emi-calculator',
  },
  {
    label: 'Settings',
    path: '/settings',
    icon: 'Settings',
    featureId: 'settings',
  },
];
